// DO NOT EDIT: autogenerated by brokkr

const radii = {
  none: "0rem",
  xs: "0.125rem",
  sm: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "62.5rem",
};

export default radii;
